interface StockboardsIconProps {
  className?: string,
  fillColor: string,
  height: number | string,
  width: number | string,
}

const StockboardsIcon = (props: StockboardsIconProps) => {
  const {
    className, fillColor, height, width,
  } = props

  return (
    <svg className={className} viewBox="0 0 40 40" style={{ width, height }}>
      <path
        style={{ fill: fillColor }}
        d="M25.6,6.4H14.4c-0.6,0-1.1,0.5-1.1,1.1v21c0,0.6,0.5,1.1,1.1,1.1h2v4h1.2v-4h5.2v4.1H24v-4.1h1.6
            c0.6,0,1.1-0.5,1.1-1.1v-21C26.6,6.8,26.2,6.4,25.6,6.4z M14.5,7.6h2.8v20.7h-2.8V7.6z M25.5,28.3h-7V7.6h7V28.3z"
      />
    </svg>
  )
}

export default StockboardsIcon
